import { useTranslate } from "@refinedev/core";
import { SettingsTileCard } from "@fawkes/ui";

import type { TileComponentProps } from "./types";

// Dieren — animal reference data (Vacht/Kleur/Kenneleigenschap/Ras). Organisatie context only.
// Migrated: the card opens the in-SPA Dieren stamgegevens detail (DierenStamgegevens).
export const ANIMALS_TILE_KEY = "animals";

const ITEM_KEYS = [
  "instellingen.item.vacht",
  "instellingen.item.kleur",
  "instellingen.item.kenneleigenschap",
  "instellingen.item.ras",
];

export function AnimalsTile({ context, onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  if (context.type !== "organization") return null;
  return (
    <SettingsTileCard
      tileKey={ANIMALS_TILE_KEY}
      icon={<img className="settings-tile-icon-image" src="/nav/nav-dog.svg" alt="" aria-hidden="true" />}
      title={t("instellingen.tile.animals.title")}
      description={t("instellingen.tile.animals.desc")}
      items={ITEM_KEYS.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("animals")}
    />
  );
}
